import React, { useState } from 'react';

import Arrow from '../Arrow';

export interface ArrowsDisabledState {
  right: boolean;
  left: boolean;
}

interface ArrowControlsProps {
  handleArrow: (
    direction: string,
    setValueForDisabledState: (value: ArrowsDisabledState) => void
  ) => void;
  showRightArrow: boolean;
  isSearchLanding?: boolean;
}

const ArrowControls: React.FC<ArrowControlsProps> = ({
  handleArrow,
  showRightArrow,
  isSearchLanding
}) => {
  const [disabledArrows, setDisabledArrows] = useState({
    right: showRightArrow,
    left: true
  });
  const setValueForDisabledState = (value: ArrowsDisabledState) => {
    setTimeout(() => {
      setDisabledArrows(value);
    }, 1000);
  };

  const handleArrowOnClick = (direction: string) => () =>
    handleArrow(direction, setValueForDisabledState);
  return (
    <>
      <Arrow
        left={true}
        disabled={disabledArrows.left}
        onClick={handleArrowOnClick('left')}
        isSearchLanding={isSearchLanding}
      />

      <Arrow
        disabled={disabledArrows.right}
        onClick={handleArrowOnClick('right')}
        isSearchLanding={isSearchLanding}
      />
    </>
  );
};

export default ArrowControls;
